export const 
    FILE_CHANGE_SELECTED_FILE = "FILE_CHANGE_SELECTED_FILE",
    FILE_OPEN_FILE_PREVIEW = "FILE_OPEN_FILE_PREVIEW";


// WEBPACK FOOTER //
// ./src/types/File.js